import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useBrandLink } from "../../../hooks/modules/ProductTitle/ProductDetailTitle/hooks/use-brand-link.js";
import { ProductDetailTitle } from "./ProductDetailTitle.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
import { isContactLensVariant } from "../../../../../../types/types/typeguards.js";
const ProductDetailTitleContainer = () => {
  const {
    activeVariant,
    product: { brandName }
  } = useProductData();
  const isContactLens = isContactLensVariant(activeVariant);
  const brandLink = useBrandLink();
  const { isPdpModelCodeDisabled } = useFeatureToggles();
  let title;
  if (isPdpModelCodeDisabled) {
    title = activeVariant.displayName.replace("brandModelCode" in activeVariant ? activeVariant.brandModelCode ?? "" : "", "").replace(/ {2,}/g, " ").trim();
  } else {
    title = activeVariant.displayName;
  }
  let subtitle = brandName;
  if (isContactLens && activeVariant.replacementFrequency) {
    subtitle = activeVariant.replacementFrequency;
  }
  return /* @__PURE__ */ React.createElement(
    ProductDetailTitle,
    {
      title,
      subtitle,
      href: brandLink,
      sku: activeVariant.sku
    }
  );
};
export {
  ProductDetailTitleContainer
};
//# sourceMappingURL=ProductDetailTitleContainer.js.map
